import React ,{useEffect,useState } from 'react'
 
import axios from 'axios';
import {  useForm } from "react-hook-form";
import { Col, Row, Form, Button  } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import './portfolio.css';
import Sidebar from '../Home/Sidebar';
import Loader from '../Loader/Loader';
 

const UpdateForm = ( ) => {
    let {id} = useParams();
    const [data, setData] = useState();
    const [portfolios, setPortfolios] = useState('');
    const [project, setProject] = useState('');
    const [techstack, setTechstack] = useState('');
 
    
    const { register } = useForm();
    useEffect(() => {
      // console.log(id,"hello ");
      const fetchCompanyData = async ( ) => {
         
        try {
          const response = await fetch(`https://apichatgptresponse.managedcoder.com/api/techstack/get/${id}`);
          const responsedata = await response.json();
          // console.log(responsedata);
          setData(responsedata)
          setPortfolios(responsedata.portfolio);
          setProject(responsedata.projects);
          setTechstack(responsedata.tech_stack);
        } catch (error) {
          console.error(error);
        }
      }
      fetchCompanyData();
    
    }, []);
    // console.log(portfolios);
    // console.log(data._id);
    // console.log(project);
    //   console.log(companyId);
    // console.log(id);
        let projects = project
        let portfolio =  portfolios
        const navigate = useNavigate();
      const handleSubmit = (event) => {
        event.preventDefault();
        fetch(`https://apichatgptresponse.managedcoder.com/api/techstack/updateTechstack/${id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ portfolio ,  projects  }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Success:", data);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
          navigate('/portfolio') 
      };
  return (
     <>
      <div className="row">
        <div className="col-3">
          <Sidebar />
        </div>
        <div className="col-9">
          <div className='article-title'>
              <Row>
              <div className="mb-3">
                <h3 className="title"> {techstack}</h3>
              </div>
                  <Col md="9">
                      <Form onSubmit={handleSubmit}>
                          <Row>
                              <Col>
                                { data ?
                                  <>
                                    <Form.Group className="mb-4"   key={data._id} >
                                      <Form.Label className="portfolio-header">Portfolio </Form.Label>                                        
                                                                        
                                      <Form.Control 
                                      
                                        type="text"
                                        placeholder="Portfolio"
                                        // rows={6}
                                        {...register("portfolio", { required: false })}
                                        value={portfolios}
                                        onChange={(e) => setPortfolios(e.target.value)}
                                      />
                                      <br/> 
                                        <Form.Label className="project-header">Projects </Form.Label>  
                                          
                                        <Form.Control 
                                        
                                        as="textarea"
                                        placeholder="Projects"
                                        rows={6}
                                        {...register("projects", { required: false })}
                                        value={project}
                                        onChange={(e) => setProject(e.target.value)}
                                      />
                                      <br/>   
                                      <div className='text-end'>
                                        <Button className='update-btn' type="submit">Update</Button> 
                                        </div>                                       
                                      </Form.Group>
                                    </>: <Loader />
                                    // <p>Loading ...</p>
                                            } 
                                    
                              </Col>
                          </Row>
                      </Form>
                  </Col>
              </Row>
          </div>
        </div>
        </div>
    </>
  )
}

export default UpdateForm
